import { mapGetters } from 'vuex';

/**
 * Sterilised Tax Inquiry ("Tax Inquiry - view only", Tulsa / Assessor's office).
 *
 * Exposes the single `isTaxViewOnly` check (store/auth/token.js) to every Tax Inquiry component,
 * so there is exactly one definition of the persona rather than a role test copied into twenty
 * templates. Use it to hide - never merely disable - anything that writes, prints, navigates out
 * of Tax Inquiry, or shows a comment.
 */
export const TaxViewOnlyMixin = {
  computed: {
    ...mapGetters('auth/token', ['isTaxViewOnly']),
    /** Inverse, for the common `v-if="canActOnTaxRecord"` reading. */
    canActOnTaxRecord() {
      return !this.isTaxViewOnly;
    },
  },
};

export default TaxViewOnlyMixin;
